var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close-form-btn"},[_c('v-btn',{staticClass:"close-btn",attrs:{"icon":"","large":!_vm.isMobile},on:{"click":_vm.backTo}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiClose))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }